import PT from 'prop-types';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';

/*
 * ProvideFocusRing is just a wrapper for `useFocusRing()` so it can be used in class components
 */

function ProvideFocusRing({
  children,
  ...rest
}) {
  return children($f7dceffc5ad7768b$export$4e328f61c538687f(rest));
}
ProvideFocusRing.propTypes = {
  within: PT.bool,
  isTextInput: PT.bool,
  autoFocus: PT.bool,
  children: PT.func.isRequired
};
ProvideFocusRing.defaultProps = {
  within: false,
  isTextInput: undefined,
  autoFocus: undefined
};

export { ProvideFocusRing as P };
//# sourceMappingURL=ProvideFocusRing--aaIAE6-.js.map
